import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWiresharkComponent } from './simple-icons-wireshark.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWiresharkComponent ],
    exports:      [ SimpleIconsWiresharkComponent ],
    bootstrap:    []
})
export class SimpleIconsWiresharkModule {}
